module.exports = "<div class=\"d-flex flex-column gmc-panel\" ng-class=::$ctrl.extraClasses><div class=gmc-panel__header>{{$ctrl.header}} <button class=close-btn ng-if=::$ctrl.closeBtn ng-click=$ctrl.onCloseClick($event)></button></div><div class=\"gmc-panel__content card\" ng-transclude></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-panel/gmc-panel.component.html
// module id = 528
// module chunks = 31